import * as React from 'react';
import { 
    TextField,
    FunctionField ,
    DateField,
    TextInput,
    SelectInput,
    EditButton,
    required
} from 'react-admin';
import { priceFormat } from '../../common/UtilFunctions';
import { StatusEnum } from '../../common/enum';
import { ProductTypeEnum } from 'src/common/enum/ProductTypeEnum';
import { StockStatusEnum } from 'src/common/enum/StockStatusEnum';
import { PriceRangeInput } from 'src/components/input/PriceRangeInput';
import { Datagrid, IfCanAccess, List } from 'src/enterprise/ra-rbac';
import { EditableDatagrid, RowForm } from "src/enterprise/ra-editable-datagrid";
import Transformer from "src/common/Transformer";

const listFilters = [
    <TextInput source="search" label="Search" alwaysOn />,
    <SelectInput source='type' choices={ProductTypeEnum}/>,
    <SelectInput source="status" choices={StatusEnum}/>,
    <SelectInput source="stock_status"  choices={StockStatusEnum}/>,
    <PriceRangeInput source="price.price" label="Price"/>
];

export const ProductList = (props) => {
    return (
        <List {...props} filters={listFilters} queryOptions={{ cacheTime: 0 }}>
            <EditableDatagrid editForm={<ProductEditForm />} mutationMode="pessimistic" noDelete rowClick="edit" actions={<></>}>
                <TextField source="id" />
                <TextField source="name"/>
                <TextField source="sku" />
                <FunctionField label="Type" source="type" render={record => ProductTypeEnum.find(x => x.id === record.type)?.name}/>
                <FunctionField label="Price" sortBy='price.price' render={(record)=>priceFormat(record.price?.price, record.price?.currency)}/>
                <FunctionField label="Status" render={record => StatusEnum.find(x => x.id === record.status)?.name}/>
                <TextField source="stock_status"/>
                <FunctionField label="Stock Quantity" sortBy='stock.quantity.sum' render={record => record.stock_quantity}/>
                <DateField source="created_at" label="Created At"/>
                <IfCanAccess action="edit">
                    <EditButton />
                </IfCanAccess>
            </EditableDatagrid>
        </List>
    );
};

const ProductEditForm = () => {
    const transform = (data) => {
        Transformer(data, {
            remove: [
                "id",
                "createdAt",
                "createdBy",
                "updatedAt",
                "updatedBy",
                "attributeSet",
                "sampleQuantity",
                "categoryIds",
                "relatedProductIds",
                "visibility",
                "children",
                "price",
                "galleryFeatured",
                "gallery",
                "stockQuantity",
                "stock",
                "attributes",
                "categories",
                "relatedProducts",
                "parent",
                "description",
                "shortDescription",
                "metaDescription",
                "metaTitle",
                "slug",
                "supplier",
                "supplierSku",
                "type",
                "weight"
            ],
            update: {
                method: "PATCH"
            },
        });

        return data;
    };
  
    return (
        <RowForm transform={transform}>
            <TextField source="id" />
            <TextField source="name"/>
            <TextField source="sku" />
            <FunctionField label="Type" source="type" render={record => ProductTypeEnum.find(x => x.id === record.type)?.name}/>
            <FunctionField label="Price" sortBy='price.price' render={(record)=>priceFormat(record.price?.price, record.price?.currency)}/>
            <FunctionField label="Status" render={record => StatusEnum.find(x => x.id === record.status)?.name}/>
            <SelectInput
                source="stock_status"
                label="Stock Status"
                choices={StockStatusEnum}
                validate={required()}
            />
            <FunctionField label="Stock Quantity" sortBy='stock.quantity.sum' render={record => record.stock_quantity}/>
            <DateField source="created_at" label="Created At"/>
        </RowForm>
    );
  };